// extracted by mini-css-extract-plugin
export default {"playOverlay":"VideoCard_playOverlay__KPC68"};